import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {CommonResponse} from "../response/common.response";
import {ApiBookingRepository} from "../services/api/booking/api.booking.repository";
import {BookingEntity} from "../entity/booking.entity";

@Injectable({
    providedIn: 'root'
})

export class Booking extends BookingEntity{
    PARAM = environment.PARAM;

    constructor(
        public apiBookingRepository?: ApiBookingRepository,
    ) {
        super();
    }

    /**
     * Armar el objeto en base a sus atributos: valor
     * Valido si el service 'UsuarioService' esta inyectado y es un objeto,
     * para pasarlo como parametro en el constructor
     */
    public static build(data: {}) {
        const busqueda = new Booking();
        // tslint:disable-next-line:forin
        for (const propiedad in data) {
            // @ts-ignore
            busqueda[propiedad] = data[propiedad];
        }
        return busqueda;
    }


    public async obtenerOperacionesOperadorFiltros(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerOperacionesOperadorFiltros(objEnvio);
    }

    public async updateReferencia(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.updateReferencia(objEnvio);
    }

    public async obtenerPlazos(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerPlazos(objEnvio);
    }

    public async obtenerCanales(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerCanales(objEnvio);
    }

    public async getLocales(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getLocales();
    }

    public async getNavesAll(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getNavesAll();
    }

    public async getOperadores(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getOperadores();
    }

    public async obtenerDatosParaVisorCliente(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerDatosParaVisorCliente(bookingId);
    }

    public async getNCNDByID(id: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getNCNDByID(id);
    }

    public async actualizarNcNd(obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.actualizarNcNd(obj);
    }

    public async getFilesBookingList(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getFilesBookingList(bookingId);
    }

    public async deleteFileByID(id: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.deleteFileByID(id);
    }

    public async obtenerListaDocumentacionOperador(params: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerListaDocumentacionOperador(params);
    }

    public async obtenerPageReportsDatosFinales(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerPageReportsDatosFinales(bookingId);
    }

    public async obtenerReporteStatusDocumentario(params: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerReporteStatusDocumentario(params);
    }

    public async obtenerReporteOperacionesFinales(params: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerReporteOperacionesFinales(params);
    }

    public async obtenerReporteMatricesOperador(params: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.obtenerReporteMatricesOperador(params);
    }

    public async getVGM(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getVGM(bookingId);
    }

    public async getMatriz(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getMatriz(bookingId);
    }

    public async getDatosFinales(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getDatosFinales(bookingId);
    }

    public async getBL(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getBL(bookingId);
    }

    public async statusOKBL(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.statusOKBL(bookingId);
    }

    public async statusCorrecionBL(bookingId: any, obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.statusCorrecionBL(bookingId, obj);
    }

    public async getStatusBLList(): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getStatusBLList();
    }

    public async enviarCorreoCorrecionBL(bookingdataId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.enviarCorreoCorrecionBL(bookingdataId);
    }

    public async getTrackingDamByID(bookingdamId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getTrackingDamByID(bookingdamId);
    }

    public async enviarCorreoDocumentoDAM(id: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.enviarCorreoDocumentoDAM(id);
    }

    public async adjuntarArchivo(file: FormData): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.adjuntarArchivo(file);
    }

    public async adjuntarDocumentoDAM(obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.adjuntarDocumentoDAM(obj);
    }

    public async adjuntarDocumentoBK(obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.adjuntarDocumentoBK(obj);
    }

    public async getCitasByFiltros(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getCitasByFiltros(objEnvio);
    }

    public async searchBookingCitaList(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.searchBookingCitaList(objEnvio);
    }
    public async listarTransporteBySede(localid: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.listarTransporteBySede(localid);
    }
    public async listarTransporteSedeByQuery(localid: any, objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.listarTransporteSedeByQuery(localid, objEnvio);
    }
    public async listarVehiculoTransporteByQuery(proveedorid: any, objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.listarVehiculoTransporteByQuery(proveedorid, objEnvio);
    }
    public async listarConductorSedeByQuery(localid: any, objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.listarConductorSedeByQuery(localid, objEnvio);
    }

    public async listarPrecintoByQuery(localid: any, objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.listarPrecintoByQuery(localid, objEnvio);
    }
    public async listarConductorBySede(localid: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.listarConductorBySede(localid);
    }
    public async guardarCita(parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.guardarCita(parms);
    }


    public async getTrackingCita(citaid: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getTrackingCita(citaid);
    }

    public async anularCita(id: any,parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.anularCita(id, parms);
    }

    public async reprogramarCita(id: any,parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.reprogramarCita(id, parms);
    }

    public async nuevaCita(id: any,parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.nuevaCita(id, parms);
    }

    public async importarExcelCita(localid: any,parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.importarExcelCita(localid, parms);
    }

    public async getEstadosCita(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getEstadosCita();
    }

    public async getCorreosOperador(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getCorreosOperador(objEnvio);
    }

    public async guardarCorreoOperador(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.guardarCorreoOperador(objEnvio);
    }

    public async getCorreoByID(id: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getCorreoByID(id);
    }
    public async eliminarCorreoByID(id: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.eliminarCorreoByID(id);
    }

    public async getTipoContenedores(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getTipoContenedores();
    }

    public async getTipoEnvioCorreo(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getTipoEnvioCorreo();
    }

    public async importarExcelCorreos(parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.importarExcelCorreos(parms);
    }

    public async getDocumentoListByTipo(booking: any, documentotipo: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getDocumentoListByTipo(booking, documentotipo);
    }
    public async eliminarDocumentoByParamsBooking(booking: any, documento: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.eliminarDocumentoByParamsBooking(booking, documento);
    }
    public async enviarCorreoEliminarDocumentoDAM(documento: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.enviarCorreoEliminarDocumentoDAM(documento);
    }

    public async guardarDatosGuiaCita(id: any,parms: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.guardarDatosGuiaCita(id, parms);
    }

    public async enviarCorreoNotificacionCita(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.enviarCorreoNotificacionCita(objEnvio);
    }

    public async getContenedoresByBooking(booking: any, dam: any, tipodocumento: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getContenedoresByBooking(booking, dam, tipodocumento);
    }

    public async getOperacionesBookingRegistroList(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getOperacionesBookingRegistroList(objEnvio);
    }

   public async addBooking(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.addBooking(objEnvio);
   }

   public async updateBooking(objEnvio: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.updateBooking(objEnvio);
   }

    public async getSemanasDisponibles(antes: any, despues: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getSemanasDisponibles(antes, despues);
    }

    public async getByID(id: any): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getByID(id);
    }

    public async getTiposContenedorList(): Promise<any> {
        // @ts-ignore
        return await this.apiBookingRepository.getTiposContenedorList();
    }

   public async enviarCorreoBooking(bookingId: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.enviarCorreoBooking(bookingId);
    }

    public async registrarNcNd(obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.registrarNcNd(obj);
    }

    public async getEstadolog(id: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getEstadolog(id);
    }
    public async enviarNotificacionNDNC(arrayIDs: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.enviarNotificacionNDNC(arrayIDs);
    }

    public async getNotasCreditoDebitoList(params: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.getNotasCreditoDebitoList(params);
    }

    public async pagoLcMulta(obj: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiBookingRepository.pagoLcMulta(obj);
    }
}
